import { Skeleton } from '../../../modules/design-system';

export interface SummaryRowProps {
  label: string;
  /** Dollar amount, or null when it isn't computed (no items / not quotable)
   *  → shows an em-dash placeholder. A real 0 renders "$0.00". */
  value: number | null;
  /** Total row — bigger, bolder, white label. */
  emphasis?: boolean;
  /** Quote in flight → show a loader in place of the amount. */
  loading?: boolean;
}

/**
 * Single row in the Delivery summary block (Shipping / Handling / Sales tax /
 * Total). `emphasis` flips the row to the Total style. While `loading` a
 * skeleton replaces the amount; otherwise a null value renders an em-dash
 * placeholder ("—") and a real 0 renders "$0.00".
 */
export function SummaryRow({ label, value, emphasis, loading }: SummaryRowProps) {
  return (
    <div className="flex items-center justify-between">
      <span
        className={emphasis ? 'text-[16px] font-semibold text-white' : 'text-[13px]'}
        style={emphasis ? undefined : { color: 'rgba(255,255,255,0.70)' }}
      >
        {label}
      </span>
      {loading ? (
        <Skeleton className={emphasis ? 'h-[22px] w-[72px] rounded' : 'h-[16px] w-[56px] rounded'} />
      ) : (
        <span
          className={
            emphasis
              ? 'text-[18px] font-bold tracking-[-0.3px] text-white tabular-nums'
              : 'text-[13px] font-semibold text-white tabular-nums'
          }
        >
          {value === null ? '—' : `$${value.toFixed(2)}`}
        </span>
      )}
    </div>
  );
}

/** Thin horizontal rule used between sections and above the summary. */
export function SummaryDivider() {
  return (
    <div
      className="my-5"
      style={{ borderTop: '1px solid rgba(255,255,255,0.10)' }}
    />
  );
}
